// Shared expense vocabulary — used by the Expenses page and by the assistant's
// expense draft card so both label a category the same way.
//
// The ids here mirror backend/models/expense.py EXPENSE_CATEGORY_LABELS, which
// is what constrains the natural-language parser. Keep the two in step.

export interface Category { id: string; name: string; color: string; }

// Plain, everyday names. Legacy ids (saas/services/catering/…) are kept so old
// rows keep their label; a few plain-language additions cover the common cases.
export const CATEGORIES: Category[] = [
  { id: 'saas',      name: 'Software',          color: '#BE5540' },
  { id: 'travel',    name: 'Travel',            color: '#1d4ed8' },
  { id: 'office',    name: 'Office',            color: '#15803d' },
  { id: 'utilities', name: 'Utilities',         color: '#0891b2' },
  { id: 'rent',      name: 'Rent',              color: '#c96b00' },
  { id: 'taxes',     name: 'Taxes',             color: '#db2777' },
  { id: 'insurance', name: 'Insurance',         color: '#0e7490' },
  { id: 'health',    name: 'Health',            color: '#16a34a' },
  { id: 'services',  name: 'Accounting & fees', color: '#4338ca' },
  { id: 'bank',      name: 'Bank fees',         color: '#525866' },
  { id: 'marketing', name: 'Marketing',         color: '#b45309' },
  { id: 'catering',  name: 'Meals',             color: '#a16207' },
  { id: 'equipment', name: 'Equipment',         color: '#475569' },
  { id: 'logistics', name: 'Shipping',          color: '#9a3412' },
  { id: 'other',     name: 'Other',             color: '#64748b' },
];

export const UNCATEGORIZED: Category = { id: '', name: 'Uncategorized', color: '#94a3b8' };

export const findCategory = (id: string | null): Category =>
  (id ? CATEGORIES.find(c => c.id === id) : undefined) || UNCATEGORIZED;

export const POPULAR_CURRENCIES = ['USD', 'EUR', 'PLN', 'GBP', 'RON', 'CHF', 'CAD', 'AUD', 'JPY'];
